import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n.use(LanguageDetector).init({
    resources: {
        en: {
            translations: {
                ReportIncident: "Report Incident",
                Timeclock: "Timeclock",
                Gardening: "Gardening",
                Mowing: "Mowing",
                Winterwork: "Winterwork",
                Teaching: "Teaching",
                Inspection: "Inspection",
                ReportBroken: "Report Breakdown",
                Workshop: "Workshop",
                RequestsAndRegistrations: "Requests / Registrations",
                Damage: "Damage",
                CheckIn: "Check in",
                CheckOut: "Check out",
                NumberOfEmployeesInGroup: "Number of Employees in group",
                Introduction: "Introduction",
                Advantages: "Advantages",
                Warehouse: "Warehouse",
                DueDate: "Due date",
                Today: "Today",
                WarehouseRequest: "Warehouse Request",
                WarehouseRequests: "Warehouse Requests",
                Photos: "Photos",
                ListNumber: "List #",
                ShowAll: "Show All",
                Worklines: "Worklines",
                Workline: "Workline",
                CreateWinterProjects: "Create Winter Projects",
                Products: "Products",
                PostalCodes: "Postal Codes"
            },
        },
        is: {
            translations: {
                ReportIncident: "Skrá tjón",
                Timeclock: "Stimpilklukka",
                Gardening: "Garðyrkja",
                Mowing: "Sláttur",
                Winterwork: "Vetrar verk",
                Teaching: "Kennsluefni",
                Inspection: "Eftirlit",
                ReportBroken: "Bilanaskráning",
                Workshop: "Verkstæði",
                RequestsAndRegistrations: "Beiðnir / Fyrirspurnir",
                Damage: "Tjón",
                CheckIn: "Stimpla inn",
                CheckOut: "Stimpla út",
                NumberOfEmployeesInGroup: "Fjöldi starfsmanna í hóp",
                Introduction: "Lýsing",
                Advantages: "Kostir",
                Warehouse: "Lager",
                DueDate: "Klára fyrir",
                Today: "Í dag",
                WarehouseRequest: "Tínslulína",
                WarehouseRequests: "Tínslulínur",
                Photos: "Myndir",
                ListNumber: "List nr.",
                ShowAll: "Sýna allt",
                Worklines: "Verklínur",
                Workline: "Verklína",
                CreateWinterProjects: "Stofna vetrarverk",
                Products: "Vörur",
                PostalCodes: "Póstnúmer"
            },
        },
    },
    fallbackLng: "en",
    debug: true,
    keySeparator: false, // we use content as keys
    ns: ["translations"], // have a common namespace used around the full app
    defaultNS: "translations",
    interpolation: {
        escapeValue: false, // not needed for react!!
        formatSeparator: ",",
    },
    react: {
        useSuspense: true,
    },
});

export default i18n;
